/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AppointmentSettingsDto } from './appointment-settings-dto';
import { ServiceFormFieldDto } from './service-form-field-dto';
/**
 * 
 * @export
 * @interface CreateServiceFormDto
 */
export interface CreateServiceFormDto {
  _id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceFormDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceFormDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateServiceFormDto
     */
    category: CreateServiceFormDtoCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateServiceFormDto
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateServiceFormDto
     */
    duration?: number;
    /**
     * 
     * @type {Array<ServiceFormFieldDto>}
     * @memberof CreateServiceFormDto
     */
    fields?: Array<ServiceFormFieldDto>;
    /**
     * 
     * @type {AppointmentSettingsDto}
     * @memberof CreateServiceFormDto
     */
    appointment?: AppointmentSettingsDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateServiceFormDto
     */
    isActive?: boolean;
    /**
     * When true, the questionnaire comes from the store shared consent template (vaccines). Set false for a custom form with its own fields.
     * @type {boolean}
     * @memberof CreateServiceFormDto
     */
    usesSharedForm?: boolean;
    /**
     * Create from a catalog template; missing name/fields are copied from it
     * @type {string}
     * @memberof CreateServiceFormDto
     */
    catalogKey?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateServiceFormDtoCategoryEnum {
    Vaccine = 'vaccine',
    Test = 'test',
    Consultation = 'consultation',
    Treatment = 'treatment',
    Other = 'other'
}

